export function CreatedWidgetsIcon() {
    return (
      
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
      className='neededFill'
        fill="#9197B3"
        d="M10.042 15.23H6.025c-3.635 0-5.188-1.553-5.188-5.188V6.025C.837 2.39 2.39.837 6.025.837h4.017c3.635 0 5.188 1.553 5.188 5.188v4.017c0 3.635-1.553 5.188-5.188 5.188zM6.025 1.84c-3.086 0-4.184 1.098-4.184 4.184v4.017c0 3.086 1.098 4.184 4.184 4.184h4.017c3.086 0 4.184-1.098 4.184-4.184V6.025c0-3.086-1.098-4.184-4.184-4.184H6.025z"
      ></path>
      <path
      className='neededFill neededStroke'
        fill="#9197B3"
        fillRule="evenodd"
        stroke="#9197B3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.3"
        d="M6.636 8c0-1.657 1.221-3 2.728-3h.909C11.779 5 13 6.343 13 8s-1.221 3-2.727 3h-.227c-.252 0-.455-.224-.455-.5s.203-.5.455-.5h.227c1.004 0 1.818-.895 1.818-2s-.814-2-1.818-2h-.91c-1.004 0-1.818.895-1.818 2 0 .276-.203.5-.454.5s-.455-.224-.455-.5zm-.909-2C4.723 6 3.91 6.895 3.91 8s.814 2 1.818 2h.91c1.004 0 1.818-.895 1.818-2 0-.276.203-.5.454-.5s.455.224.455.5c0 1.657-1.221 3-2.728 3h-.909C4.221 11 3 9.657 3 8s1.221-3 2.727-3h.228c.25 0 .454.224.454.5s-.203.5-.454.5h-.228z"
        clipRule="evenodd"
      ></path>
    </svg>
    );
  }